import React from 'react';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/types/customTooltip';

interface IProps {
  title: string;
  className?: string;
}

const MenuManagTabItemCaloriesHeader: React.FC<IProps> = (props: IProps): JSX.Element => {
  return (
    <div className={`d-flex flex-row align-items-center justify-content-between ${props.className || ''}`}>
      <Text
        type={TEXT.BLOCK_HEADER}
        text={props.title}
        tooltip={{
          message: 'ap_item_calories_field_infotip',
          position: TOOLTIP_POSITION.PORTAL,
          iconSize: 16,
        }}
      />
    </div>
  );
};

export default MenuManagTabItemCaloriesHeader;
